//Data Count
export const CLEAR_DATA_COUNT = "CLEAR_DATA_COUNT";
export const GET_DATA_COUNT = "GET_DATA_COUNT";
export const GET_DATA_COUNT_SUCCESS = "GET_DATA_COUNT_SUCCESS";

//Data List
export const CLEAR_DATA_LIST = "CLEAR_DATA_LIST";
export const GET_DATA_LIST = "GET_DATA_LIST";
export const GET_DATA_LIST_SUCCESS = "GET_DATA_LIST_SUCCESS";
export const GET_PAGELESS_DATA_LIST = "GET_PAGELESS_DATA_LIST";
export const GET_PAGELESS_DATA_LIST_SUCCESS = "GET_PAGELESS_DATA_LIST_SUCCESS";

//Data Item
export const CREATE_DATA_ITEM = "CREATE_DATA_ITEM";
export const CREATE_DATA_ITEM_FAILURE = "CREATE_DATA_ITEM_FAILURE";
export const CREATE_DATA_ITEM_SUCCESS = "CREATE_DATA_ITEM_SUCCESS";
export const DELETE_DATA_ITEM = "DELETE_DATA_ITEM";
export const GET_DATA_ITEM = "GET_DATA_ITEM";
export const GET_DATA_ITEM_FAILURE = "GET_DATA_ITEM_FAILURE";
export const GET_DATA_ITEM_SUCCESS = "GET_DATA_ITEM_SUCCESS";
export const UPDATE_DATA_ITEM = "UPDATE_DATA_ITEM";
export const UPDATE_DATA_ITEM_FAILURE = "UPDATE_DATA_ITEM_FAILURE";
export const UPDATE_DATA_ITEM_SUCCESS = "UPDATE_DATA_ITEM_SUCCESS";
export const GET_RELATIONSHIP_ITEMS = "GET_RELATIONSHIP_ITEMS";
export const GET_RELATIONSHIP_ITEMS_SUCCESS = "GET_RELATIONSHIP_ITEMS_SUCCESS";
export const UPDATE_LOCAL_DATA = "UPDATE_LOCAL_DATA";

//Data File
export const CLEAR_DATA_FILE = "CLEAR_DATA_FILE";
export const GET_DATA_FILE = "GET_DATA_FILE";
export const GET_DATA_FILE_FAILURE = "GET_DATA_FILE_FAILURE";
export const GET_DATA_FILE_SUCCESS = "GET_DATA_FILE_SUCCESS";
export const CLEAR_S3_DATA_FILE = "CLEAR_S3_DATA_FILE";
export const GET_S3_DATA_FILE = "GET_S3_DATA_FILE";
export const GET_S3_DATA_FILE_FAILURE = "GET_S3_DATA_FILE_FAILURE";
export const GET_S3_DATA_FILE_SUCCESS = "GET_S3_DATA_FILE_SUCCESS";
export const POST_DATA_FILE = "POST_DATA_FILE";
export const POST_DATA_FILE_FAILURE = "POST_DATA_FILE_FAILURE";
export const POST_DATA_FILE_SUCCESS = "POST_DATA_FILE_SUCCESS";

//OTHER
export const SIMPLE_POST = "SIMPLE_POST";
export const SIMPLE_POST_FAILURE = "SIMPLE_POST_FAILURE";
export const SIMPLE_POST_SUCCESS = "SIMPLE_POST_SUCCESS";

// GRAPHQL
export const GRAPHQL = "GET_GRAPHQL";
export const GRAPHQL_SUCCESS = "GET_GRAPHQL_SUCCESS";
export const GRAPHQL_FAILURE = "GET_GRAPHQL_FAILURE";



// WEBPACK FOOTER //
// ./src/utils/data/dataActionTypes.js